import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { WarehouseService } from "src/app/services/warehouse.service";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AuthenticationService } from "../../authentication/authentication/authentication.service";
declare let $: any;

@Component({
    selector: "app-analytics",
    templateUrl: "./analytics.component.html",
    styleUrls: ["./analytics.component.scss"]
})
export class AnalyticsComponent implements OnInit {

    companyId = this.authService.getCurrentCompanyId();

    dashboardUrl!: SafeResourceUrl;
    dashboardProducts!: SafeResourceUrl;
    dashboardWarehouse!: SafeResourceUrl;
        
    iframeError = false;
    iframeError2 = false;
    iframeError3 = false;

    constructor(
        private cdRef: ChangeDetectorRef,
        public sanitizer: DomSanitizer,
        private authService : AuthenticationService
    ) {
        
    }

    onIframeError() {
        console.error('Error al cargar el iframe');
        this.iframeError = true; // Oculta el iframe si falla
      }

    onIframeLoad(index: number) {
        console.log(`Iframe ${index} cargado.`);
    }

    ngOnInit() {
        this.companyId = this.authService.getCurrentCompanyId();

        setTimeout(() => {
            this.dashboardUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
                `https://lookerstudio.google.com/embed/reporting/c551b32d-e98c-498d-83b4-355045b83548/page/fORwE?params=%7B"df4":"include%25EE%2580%25801%25EE%2580%2580IN%25EE%2580%2580${this.companyId}"%7D&hideToolbar=true`
            );
    
            this.dashboardProducts = this.sanitizer.bypassSecurityTrustResourceUrl(
                `https://lookerstudio.google.com/embed/reporting/92e59e2c-c432-47ae-9283-d71c064b5d74/page/6YXwE?params=%7B"df5":"include%25EE%2580%25801%25EE%2580%2580IN%25EE%2580%2580${this.companyId}"%7D&hideToolbar=true`
            );
    
            this.dashboardWarehouse = this.sanitizer.bypassSecurityTrustResourceUrl(
                `https://lookerstudio.google.com/embed/reporting/a4bd394f-563e-4219-9b21-b1d455a6e8b5/page/qEYwE?params=%7B"df2":"include%25EE%2580%25801%25EE%2580%2580IN%25EE%2580%2580${this.companyId}"%7D&hideToolbar=true`
            );
        }, 500);

        this.cdRef.detectChanges();
    }

}
